module.exports = __webpack_public_path__ + "img/logo-opengov-kreis.5fcea4ea.png";